module.exports = __webpack_public_path__ + "labioplastika_8_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_8_after_tn.jpg
// module id = 1549
// module chunks = 0